import { useLayoutEffect, useRef, useState } from 'react';

const BASE_TABLE_HEIGHT = 400;
const TABLE_BOTTOM_PADDING = 42;

export const useTableHeight = ({
  baseHeight = BASE_TABLE_HEIGHT,
  bottomPadding = TABLE_BOTTOM_PADDING,
} = {}) => {
  const containerRef = useRef(null);
  const [height, setHeight] = useState(baseHeight);

  useLayoutEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        const topOffset = containerRef.current.getBoundingClientRect().top;
        const newHeight = window.innerHeight - topOffset - bottomPadding;
        setHeight(newHeight);
      }
    };

    updateHeight();

    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, [bottomPadding]);

  return { containerRef, height };
};

export default useTableHeight;
